import { Image } from '@chakra-ui/image';
import {
    Flex, Box
} from '@chakra-ui/layout';
import { Text } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '../../../../../../../components/three-essentials/button/button';
import { useSelectorEditMyProfileUrl } from '../../../../../../../configuration';
import { fetchGetUserProfilesRequest } from '../../../../../../../user-profiles/user-profiles.actions';
import {
    selectProfilePicture, useSelectedProfilePicture
} from '../../../profile-picture-upload-modal';
import CloseIcon from '../../icons/close.svg';
import { ProfilePicture } from '../user-profile/components/profile-picture/profile-picture';
import { updateProfileImage } from '../user-profile/user-profile-modal.actions';
import { useSelectorUserProfile } from '../user-profile/user-profile-selectors';
import { handleCloseModal } from '../user-profile/user-profile.utils';
import {
    Container, CloseButtonWrapper, CloseButton, MyProfileWrapper, Divider, Description, Title, Section, Dash
} from './three-essentials-user-profile.styled';

export const ThreeEssentialsUserProfile = () => {
    const dispatch = useDispatch();
    const userDetails = useSelectorUserProfile();
    const selectedProfilePicture = useSelectedProfilePicture();
    const [profileImage, setProfileImage] = useState(userDetails?.profileImage || '');
    const handleRemoveProfileImage = async () => {
        await dispatch(updateProfileImage(JSON.stringify({ profileImage: '' })));
        setProfileImage('');
        await dispatch(selectProfilePicture(''));
        await dispatch(fetchGetUserProfilesRequest());
    };
    const editMyProfileUrl = useSelectorEditMyProfileUrl();
    const CapitalizeFirstLetter = (word?: string) => {
        if (!word) return null;

        return String(word).charAt(0).toUpperCase() + String(word).slice(1);
    };

    return (
        <Container>
            <Section position={'relative'} mt={'17px'}>
                <Flex w={'100%'} alignItems={'center'}>
                    <ProfilePicture
                        profileImage={selectedProfilePicture || profileImage}
                        handleRemoveProfileImage={handleRemoveProfileImage}
                    />
                    <MyProfileWrapper>
                        <Text fontSize={'32px !important'} mb={'12px'}>
                            <Trans id={'header.myprofile'} />
                        </Text>
                        <Title><Trans id={'profile.username'} />:</Title>
                        <Description noOfLines={2}>{userDetails?.email}</Description>
                    </MyProfileWrapper>
                </Flex>
                <CloseButtonWrapper onClick={() => handleCloseModal(dispatch)}>
                    <CloseButton
                        data-testid={'close-user-modal'}
                        onClick={() => handleCloseModal(dispatch)}
                    >
                        <Image src={CloseIcon} />
                    </CloseButton>
                </CloseButtonWrapper>
            </Section>
            <Divider />
            <Section>
                <Box mr={'24px'} minW={'50px'}>
                    <Title><Trans id={'profile.title'} /></Title>
                    <Description overflow={'hidden'}>{CapitalizeFirstLetter(userDetails?.title) || <Dash>-</Dash>}</Description>
                </Box>
                <Box overflow={'hidden'}>
                    <Title><Trans id={'firstname'} /></Title>
                    <Description noOfLines={2}>{userDetails?.firstName}</Description>
                </Box>
            </Section>
            <Divider />
            <Section>
                <Box overflow={'hidden'}>
                    <Title><Trans id={'lastname'} /></Title>
                    <Description noOfLines={2}>{userDetails?.lastName}</Description>
                </Box>
            </Section>
            <Divider />
            <Section>
                <Box overflow={'hidden'}>
                    <Title><Trans id={'email'} /></Title>
                    <Description noOfLines={2}>{userDetails?.email}</Description>
                </Box>
            </Section>
            <Divider />
            <Section minHeight={'fit-content'} mb={0}>
                <Button
                    title={t`profile.editMyProfile`}
                    overrideStyles={{ minW: '100%' }}
                    clickHandler={() => window.open(editMyProfileUrl)}
                />
            </Section>
        </Container>
    );
};
